export interface Int_Menu_Items {
  ID: number;
  Name: string;
  InnerHtml: string;
  Image: string;
  iCount: number | string;
  isSelected: boolean;
}

// Excel Export Drawer Component
export interface Int_ExcelDataFields {
  label: string;
  key: string;
  FieldType: "number" | "string" | "date" | "date-time";
  IsSelected: boolean;
}

export interface Int_ExcelExportAction {
  HEADING: string;
  DATA: any[];
  FIELDS: Int_ExcelDataFields[];
}

export interface Int_Excel_Export_File_Config {
  items: any[];
  fileName: string;
  columns?: Int_ExcelDataFields[];
  type?: "excel" | "csv";
  heading?: string;
}

// TableColumnsViewComponent
export interface Int_TableColumn {
  title: string;
  dataIndex: number;
  sortByKey: string;
  viewKey: string;
  subKey?: string;
  type: TABLE_COLUMN_TYPE;
  headerAlign: "center" | "start" | "end";
  customHeaderClass?: string;
  bodyAlign: "center" | "start" | "end"; // Will not work for column CUSTOM
  dateFormat?: string; // Will only work for column DATE
  viewFunction?: (item: any) => any; // Will only work for column FUNCTION
  customBodyClass?: string;
  width?: number;
  isSortable?: boolean;
  isSelected?: boolean;
}

export interface Int_SortEvent {
  sortOrder: string;
  sortBy: string;
}

export enum TABLE_COLUMN_TYPE {
  TEXT = "text",
  DATE = "date",
  CHECKBOX = "CHECKBOX",
  ACTION = "ACTION",
  FUNCTION = "FUNCTION",
  CUSTOM = "custom",
  CUSTOM_DATE = "custom_date",
  DATE_TIME = "date_time",
  LIST = "list",
}
